import React from "react";

function currencyFormat(num) {
  return num?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export const ConsolidatedBuildingSignForm = React.forwardRef((props, ref) => {
  const getPageMargins = () => {
    return `
    @page {
        margin: 0;
        size: 8.5in 11in;
    }

    .top-section {
        position: absolute;
        top: 0.5in;
        left: 0.5in;
        right: 0.5in;
        height: 4in;
        text-align: center;
        transform: translateX(50px); /* Shift right by 30px */
    }

    .bottom-section {
        position: absolute;
        bottom: 0.5in;
        left: 0.5in;
        right: 0.5in;
        height: 4in;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        transform: translateX(30px); /* Shift right by 30px */
    }

    .sizeText {
        font-size: 130pt;
        font-weight: bold;
        letter-spacing: 0.05em;
        margin: 0;
    }

    .priceText {
        font-size: 100px;
        font-weight: bold;
        letter-spacing: 0.05em;
        margin: -50px 0 0 0; /* Negative top margin to pull it up */
    }

    .monthlyPriceText {
        font-size: 130px;
        font-weight: bold;
        letter-spacing: 0.05em;
        margin: 0;
        margin-top: -250px; /* Large negative margin to pull the monthly price down closer to list price */
    }

    @media print {
        .top-section, .bottom-section {
            page-break-inside: avoid;
        }
        
        .no-print {
            display: none;
        }
    }

    .print-form {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        font-family: Arial, sans-serif;
    }

    .size {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .price {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    `;
  };

  return (
    <>
      <style>{getPageMargins()}</style>
      <div ref={ref} className="print-form">
        <div className="top-section">
          <div className="size">
            <p className="sizeText">{props.size}</p>
          </div>
        </div>
        <div className="bottom-section">
          <div className="price">
            <p className="monthlyPriceText">
              ${currencyFormat(props.monthlyPrice.toString().replace("$", ""))}
              /mo
            </p>
            <p className="priceText">
              ${currencyFormat(props.listPrice.toString().replace("$", ""))}
            </p>
            <p>Your price may be different! Ask an associate for a quote!</p>
          </div>
        </div>
      </div>
    </>
  );
});

export default ConsolidatedBuildingSignForm;
